export default "./dist/stdassets/cursors/digitizePolygon.cur";